import React from "react";
import { Link } from "react-router-dom";

import PageBanner from "../../layouts/PageBanner";
import shape2 from "../../assets/images/pattern/shape2.png";
import shape3 from "../../assets/images/pattern/shape3.png";
import shape5 from "../../assets/images/pattern/shape5.png";
import shape1 from "../../assets/images/pattern/shape1.png";
import shape6 from "../../assets/images/pattern/shape6.png";
import PPt from "../../assets/images/project/Natural disaster in Chennai.pptx";
import { IMAGES, Project, Sanitation } from "../../constant/theme";
import { Table } from "reactstrap";

const SanitationSchool = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="Project" />

        <section className="content-inner bg-light section-pattren1">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-12 align-self-center">
                <div className="section-head m-b30">
                  <h2 className="title mb-3 padding">School Hygiene Initiative, Rasipalayam </h2>
                </div>
              </div>
            </div>

            <div className=" dz-card blog-single sidebar">
              <div>
                <div className="dz-meta">
                  <ul>
                    <li className="post-date">
                      <i className="fa-solid fa-calendar-days"></i> August 8th,
                      2025
                    </li>
                    <li className="post-author">
                      <Link to={"#"}>
                        <i className="fa-solid fa-minus"></i> Tamil Nadu
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dz-post-text">
                  <div>
                    {/* <h1 className="dz-title">
                      School Sanitation Groundbreaking, Govt. Hr. Sec. School,
                      Rasipalayam
                    </h1> */}
                    <p>
                      Rasipalayam village, located in Tamil
                      Nadu’s Coimbatore district, the San Antonio Tamil Sangam,
                      in collaboration with the Rasipalayam Do Something
                      Organization Trust, has embarked on a noble endeavor to
                      construct modern toilet facilities at the government
                      higher secondary school, ensuring a dignified life for
                      students. The foundation stone-laying ceremony and initial
                      work for this project commenced auspiciously on August 8.
                    </p>

                    <div className="row mb-3">
                      {/* First column with two stacked images */}
                      <div className="col-6 d-flex flex-column">
                        <div className="mb-2">
                          <img
                            src={Sanitation.sanitation1}
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <div>
                          <img
                            src={Sanitation.sanitation2}
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                      </div>

                      {/* Second column with the last image */}
                      <div className="col-6">
                        <img
                          src={Sanitation.sanitation3}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SanitationSchool;
